import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import LabeledValue from '../components/LabeledValue'

const useStyles = makeStyles(() => ({
  header: {
    padding: '1rem',
    backgroundColor: 'var(--color-neutral-500)',
    borderBottom: '1px solid var(--color-neutral-600)'
  }
}))

const ObjectMappingHeader = ({ mapping }) => {
  const classes = useStyles()

  return (
    <header className={classes.header}>
      <LabeledValue label='Destination Type'>{mapping.destinationType}</LabeledValue>
      <LabeledValue label='Mapping ID'>{mapping.objectMappingId}</LabeledValue>
      <LabeledValue label='Target ID'>{mapping.ingestionTargetId ? mapping.ingestionTargetId : '<NULL>'}</LabeledValue>
    </header>
  )
}

ObjectMappingHeader.propTypes = {
  mapping: PropTypes.shape({
    objectMappingId: PropTypes.number,
    destinationType: PropTypes.string,
    ingestionTargetId: PropTypes.number
  })
}

export default ObjectMappingHeader
